import WorkIcon from '@mui/icons-material/Work';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type SoleTraderTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * SoleTraderTile is a pre-configured EntityTypeTile for the Sole Trader entity type.
 *
 * @example
 * ```tsx
 * <SoleTraderTile
 *   selected={selectedType === 'sole-trader'}
 *   onClick={() => setSelectedType('sole-trader')}
 * />
 * ```
 */
const SoleTraderTileComponent = ({
  selected,
  onClick,
  dataTestId,
}: Readonly<SoleTraderTileProps>) => {
  return (
    <EntityTypeTile
      icon={<WorkIcon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      title="Sole Trader"
      description="You run a business in your own name (or a business name) and you're personally responsible for it."
      hint="Choose this if you're a freelancer, contractor, or small business owner working for yourself."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const SoleTraderTile = withClarityTheme(SoleTraderTileComponent);
